import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import edit from "../../../assets/images/edit.png";
import switches from "../../../assets/images/switch.png";
import trash from "../../../assets/images/trash.png";
import BellR from "../../../assets/images/bell_de.png";
import BellG from "../../../assets/images/bell_flt.png";
import MailR from "../../../assets/images/mail_dlt.png";
import MailG from "../../../assets/images/mail_at.png";
import Userview from "../../../assets/images/useer_view.png";
import Select from 'react-select';
import { toast } from 'react-toastify';

import { withToken, withRFSToken } from '../../../Services/axios.js';
import { USERDELETE, AIRLINEUSER, AIRLINESTATION, AIRLINESAVEUSER, AIRLINEREMOVEUSER } from '../../../Utils/conts.js';
import ConfModal from '../../../Components/common/ConfModal.js';

const UserSettings = ({ isModal, ruleId }) => {

  const isMounted = useRef(false);
  const [modalConf, setModalConf] = useState(false);
  const [confData, setConfData] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [editId, setEditId] = useState('');
  const [deleteId, setDeleteId] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [deleteFunction, setDeleteFunction] = useState(null);
  const userRole = [
    { label: 'User', value: 'E' },
    { label: 'Admin', value: 'S' },
    // {label: 'Company Super Admin', value: 'SA'}
  ];

  const handleAddButtonClick = () => {

    setModalShow(true);
  };
  const handleEditButtonClick = (userId) => {
    setEditId(userId);
    setModalShow(true, { id: userId });
  };
  const handleModalClose = () => {
    setModalShow(false);
    setFormData({
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      station_code: '',
      user_type: 'E'
    });
    setEditId('');

  };

  const [gridData, setGridData] = useState([]);
  const [stationList, setStationList] = useState([]);
  const fetchStation = async () => {
    try {
      const res = await withRFSToken.post(AIRLINESTATION, { status: 'A' })
        .then(function (res) {
          const innerData = res.data.Rows;
          // setGridData(innerData);
          const transformData = innerData ? innerData.map((item) => ({
            label: item.station_code,
            value: item.station_code
          })) : []
          setStationList(transformData)
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchData = async () => {
    const payload = ruleId ? { rule_id: ruleId } : {}
    try {
      const res = await withRFSToken.post('uld-setting/get-user-list', payload)
        .then(function (res) {
          // if (res.data.response_code === 200) {
          const innerData = res.data.Rows;
          console.log("🚀 ~ .then ~ innerData:", innerData)
          // const transformedData = innerData ? innerData.map(item => ({
          //   value: item.code,
          //   label: item.code +'-'+ item.name
          // })) : [];    
          setGridData(innerData);
        });
      // } else {
      //   toast.error(res.data.response_msg)
      // }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    if (isMounted.current) return;
    // Call the fetchData function to fetch data from the API
    setIsLoading(false);
    setGridData({ Active: {} });
    // fetchData();
    fetchStation();
    isMounted.current = true;
  }, []);

  const openConfModal = (dta, pos) => {
    if (pos == 'sw') {
      setConfData({
        header: 'Authorize/ Unauthorize User',
        subHeader: `'Are you sure you want to '${dta.authorize == 0 ? 'authorize' : 'unauthorize'} this user?`,
        // modalConf: { tabChangeConf },
        // closeModal: { confModalClose },
        data: dta,
        primaryBtn: 'Yes',
        secondaryBtn: 'No',
      })
      setModalConf(true);
    } else {
      // setSelectedButton(button)
    }
  }
   const handleAuthorize = async (data) => {
      const payload = ruleId ? { rule_id: ruleId } : {}
      try {
        const res = await withRFSToken.post('make-authorized', { id: data.id, authorized: data.authorized == 0 ? 1 : 0 })
          .then(function (res) {
            console.log("check",res?.data);
            if(res?.data?.response_code == 200){
            confModalClose()
            toast.success(res?.data?.response_msg)
            window.$(gridRef.current).jqxGrid("updatebounddata");
          }else{
            toast.error(res?.data?.response_msg)
          }
          });
  
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
   const tabChangeConf = () => {
    handleAuthorize(confData.data)
  }
  const confModalClose = () => {
    setModalConf(false);
    window.$(gridRef.current).jqxGrid("updatebounddata");
    // fetchData()
    // loadGrid()
  }

  // const fetchDataDetails = async (id) => {
  //   try {
  //     const res = await withRFSToken.post(USERDETAILS, { user_id: id })
  //       .then(function (res) {
  //         const innerData = res.data.data;
  //         console.log("🚀 ~ .then ~ innerData:xxx", innerData)
  //         const userId = innerData.user_id;

  //         const portalAccess = innerData.portal_access;
  //         const portalAccessObject = {};
  //         if (portalAccess) {
  //           portalAccess.forEach((key) => {
  //             portalAccessObject[key] = true;
  //           });
  //           setFormData({
  //             ...innerData,
  //             station_code: innerData.port_code,
  //             portal_access: portalAccessObject
  //           });
  //           handleEditButtonClick(userId);
  //           console.log("🚀 ~ .then ~ portalAccessObject:", portalAccessObject)
  //         }

  //         return portalAccessObject;
  //         // const transformedData = innerData ? innerData.map(item => ({
  //         //   value: item.code,
  //         //   label: item.code +'-'+ item.name
  //         // })) : [];    
  //         // setStationList(innerData);
  //       });

  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };
  const gridRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [filterApplied, setFilterApplied] = useState(false);
  let checkUlds = [];
  let filterForCheck = false;
  useEffect(() => {
    // console.log("🚀 ~ ExportActive ~ PPP:", gridData)
    const rawData = JSON.parse(localStorage.getItem('Handler_stn'));
    console.log("🚀 ~ useEffect ~ rawData:", rawData)
    let stnName;
    if (rawData && typeof rawData === 'object' && !Array.isArray(rawData)) {
      stnName = rawData.station_name
    } else { stnName = null }
    if (gridRef.current) {
      var token = "Bearer " + localStorage.airlinetoken;
      const source = {
        datatype: 'json',
        datafields: [
          { name: 'user_id', type: 'string' },
          { name: 'authorized', type: 'string' },
          { name: 'user_id_enc', type: 'string' },
          { name: 'first_name', type: 'string' },
          { name: 'last_name', type: 'string' },
          { name: 'email_id', type: 'string' },
          { name: 'contact_number', type: 'string' },
          { name: 'role', type: 'string' },
          { name: 'department', type: 'string' },
          { name: 'cdm_access', type: 'string' },
          { name: 'edit_access', type: 'string' },
          { name: 'cclp_access', type: 'string' },
          { name: 'department_access', type: 'string' },
          { name: 'station_code', type: 'string' },
          { name: 'address', type: 'string' },
          { name: 'address2', type: 'string' },
          { name: 'city', type: 'string' },
          { name: 'country', type: 'string' },
          { name: 'postal_code', type: 'string' },
          { name: 'status', type: 'string' },
        ],
        // localdata: gridData,
        url: `${process.env.REACT_APP_RFS_URL}uld-setting/get-user-list?station_code=${stnName}`,
        beforeSend: function (jqXHR) {
          jqXHR.setRequestHeader('Authorization', token);
        },
        pagesize: 50,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRef.current).jqxGrid('clearselection');
          window.$(gridRef.current).jqxGrid("updatebounddata", "filter");


          // setTimeout(() => {
          //     const rows = window.$(gridRef.current).jqxGrid('getrows');

          //     console.log("rows", rows);
          //     (checkUlds).forEach(uldNumber => {
          //         console.log(checkUlds);
          //         rows.forEach((element, index) => {
          //             if (element.uld_number == uldNumber) {
          //                 window.$(gridRef.current).jqxGrid('selectrow', index);
          //             }
          //         });
          //     });
          // }, 4000);
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
          // setTotalRows({ totalUlds: data.activeCount });
          // setTotalRowsR({ totalUlds: data.archiveCount });
        },
        sort: function () {
          window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);

      const columns = [
        // { text: 'Select', datafield: 'selected', columntype: 'checkbox', width: 50 },filtertype: 'bool',
        // { text: 'Select', datafield: 'selected', columntype: 'checkbox', width: 50 },

        {
          text: 'Activities',
          cellsrenderer: function () {
            return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /><img src="' + switches + '" class="row_switch" /><img src="' + trash + '" class="row_delete" /></div>';
          },
          width: '7%'
        },
        { text: 'First Name', filtertype: 'textbox', datafield: 'first_name', width: '10%', cellclassname: '', },
        { text: 'Last Name', filtertype: 'textbox', datafield: 'last_name', width: '10%', cellclassname: '', },
        { text: 'Email Id', filtertype: 'textbox', datafield: 'email_id', width: '20%', cellclassname: '', },
        { text: 'Role', filtertype: 'textbox', datafield: 'role', width: '10%', cellclassname: '', },
        { text: 'Department', filtertype: 'textbox', datafield: 'department', width: '17%', },
        { text: 'CDM Access', filtertype: 'textbox', datafield: 'cdm_access', width: '10%' },
        { text: 'Visitor Auth', datafield: 'authorized', width: '7%', filtertype: 'checkedlist',
          filteritems: [
            { label: 'Yes', value: 'Yes' },
            { label: 'No', value: 'No' },
          ],
          cellsrenderer: (row, column, val, rowData) => {
            // console.log("🚀 ~ UserSettings ~ val:", rowData)
            const isChecked = val === 1 ? 'checked' : '';
            const switchColor = val === 1 ? 'bg-success' : 'bg-danger';
            const id = rowData.id;
            return `
            <div style="margin-top:13px;">
              <div class="form-check form-switch">
                <input 
                  class="form-check-input switchActiveInactive door_switchActiveInactive" 
                  type="checkbox" 
                  role="switch" 
                  ${isChecked}
                />
              </div>
            </div>`;
          }
        },
        { text: 'CCLP Access', filtertype: 'textbox', datafield: 'cclp_access', width: '10%' },
        { text: 'Edit Access', filtertype: 'textbox', datafield: 'edit_access', width: '10  %' },
        { text: 'Department Access', filtertype: 'textbox', datafield: 'department_access', width: '14%' },
        { text: 'Station Code', filtertype: 'textbox', datafield: 'station_code', width: '14%' },
        { text: 'Address', filtertype: 'textbox', datafield: 'address', width: '14%' },
        { text: 'Address2', filtertype: 'textbox', datafield: 'address2', width: '14%' },
        { text: 'City', filtertype: 'textbox', datafield: 'city', width: '14%' },
        { text: 'Country', filtertype: 'textbox', datafield: 'country', width: '14%' },
        { text: 'Postal Code', filtertype: 'textbox', datafield: 'postal_code', width: '14%' },
        { text: 'Status', filtertype: 'textbox', datafield: 'status', width: '14%' },
      ];


      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: true,
        sortable: true,
        altrows: false,
        enabletooltips: true,
        editable: false,
        // selectionmode: 'checkbox',
        pageable: true,
        pageSize: 10,
        pagerButtonsCount: 10,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 50,
        columnsheight: 45,
      };


      window.$(gridRef.current).jqxGrid(gridOptions);
      window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

      window.$(gridRef.current).on('click', '.row_edit', function (row) {

        const rowDiv = window.$(this).closest('[role="row"]');


        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        const id = rowData.user_id
        console.log("🚀 ~ rowDiv:", rowData)
        // fetchDataDetails(id);
        const rowBookingId = rowData.booking_id;
        setEditId(id);
        setModalShow(true);
        setFormData({
          first_name: rowData.first_name || '',
          last_name: rowData.last_name || '',
          email: rowData.email_id || '',
          phone_number: rowData.contact_number || '',
          station_code: rowData.station_code || '',
          user_type: rowData.user_type == 'User' ? 'E' : 'S',
          sddress: rowData.address
        })
      });
      window.$(gridRef.current).on('click', '.form-switch', function (row) {

        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        const dta = { id: rowData.user_id, authorized: rowData.authorized }
        // handleAuthorize(dta)
        openConfModal(dta, 'sw')

      });
      window.$(gridRef.current).on('click', '.row_switch', function (row) {

        const rowDiv = window.$(this).closest('[role="row"]');

        const rowIndex = window.$(rowDiv).attr('row-id');
        const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);

        if (boundIndex !== undefined) {
          const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
          // console.log('Global Index:', globalIndex); 
          const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
          if (rowData) {
            // console.log('Row Data:', rowData);
            handleUserSwitch(rowData.user_id_enc);

          } else {
            console.error('No data found for the given row index.');
          }
        } else {
          console.error('Bound index could not be retrieved. Check the row index and data binding.');
        }


      });
      window.$(gridRef.current).on('click', '.row_delete', function (row) {

        const rowDiv = window.$(this).closest('[role="row"]');


        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        const id = rowData.user_id
        setDeleteId(id);
        console.log("🚀 ~ rowDiv:", rowData)

        handleShowConfirmation(deleteRow);
        const rowBookingId = rowData.booking_id;


      });

    }

  }, [gridData]);

  const handleUserSwitch = async (id) => {
    try {
      const res = await withRFSToken.post('rfs-login', { user_id: id, ip_address: '', login_by: id })
        .then(function (res) {
          const innerData = res.data.response_data;
          // console.log("🚀 ~ .then ~ innerData:654", innerData)
          const token = localStorage.getItem('airlinetoken')
          localStorage.setItem('Husertoken', token)
          localStorage.setItem('airlinetoken', innerData.token)
          window.location.href = '/Dashboard';
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    station_code: '',
    user_type: 'E'
  });



  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setFormData((prevData) => ({
        ...prevData,
        portal_access: {
          ...prevData.portal_access,
          [name]: checked
        }
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value
      }));
    }
    // setFormData((prevData) => ({
    //   ...prevData,
    //   // [name]: type == 'checkbox' ? { ...prevData, [value]: checked } : value
    // }));
    // console.log('202', formData);
  };
  const validateFormData = () => {
    let isValid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Function to validate email
    const validateEmail = (email) => {
      return emailRegex.test(email);
    };
    // if (!formData.first_name) {
    //   console.log('Text input is required');
    //   toast.error('First Name must not be blank');
    //   isValid = false;
    // } else if (!formData.last_name) {
    //   console.log('Text input is required');
    //   toast.error('Last Name must not be blank');
    //   isValid = false;
    // } else if (!formData.email) {
    //   console.log('Text input is required');
    //   toast.error('Email must not be blank');
    //   isValid = false;
    // } 
    if (!validateEmail(formData.email)) {
      console.log('Invalid email address');
      toast.error('Invalid email address');
      isValid = false;
    }
    // else if (!formData.phone_number) {
    //   console.log('Text input is required');
    //   toast.error('Phone Number must not be blank');
    //   isValid = false;
    // } else
    //   if (!/^\d{10}$/.test(formData.phone_number)) {
    //     console.log('10');
    //     toast.error('Phone Number must be 10 Digits');
    //     isValid = false;
    //   } 
    else {
      return isValid;
    }
  };
  const handleSubmit = async () => {
    if (validateFormData()) {
      // You can send formData to your API endpoint here
      //   const selectedAccess = Object.entries(formData.portalAccess)
      // .filter(([key, value]) => value)
      // .map(([key]) => key);
      const stationcode = stationList.find(lst => lst.port_code == formData.station_code);
      // console.log("🚀 ~ handleSubmit ~ stationcode:", stationcode)
      // const portalAccessArray = Object.keys(formData.portal_access)
      //   .filter(key => formData.portal_access[key]);

      // Create the final data object for submission
      let finalData = {};
      if (editId) {
        finalData = {
          ...formData,
          user_id: editId,
          // port_address: stationcode.port_address,
          // portal_access: portalAccessArray
        };
      } else {
        finalData = {
          ...formData,
        };
      }

      console.log('fdaa', finalData);
      try {
        const res = await withRFSToken.post(AIRLINESAVEUSER, finalData);
        if (res.data.response_code === 200) {
          if (editId) {
            toast.success('User Data Updated Successfully');
          } else {
            toast.success('User Data Saved Successfully');
          }
          setFormData({ first_name: '', last_name: '', email: '', phone_number: '', station_code: '', user_type: 'E' })
          //fetchData();
          window.$(gridRef.current).jqxGrid('updatebounddata');
          handleModalClose();
          setEditId('');
        } else {
          toast.error(res.data.response_msg);
        }

      } catch (error) {
        console.error('Error sending request:', error);
      }

    }
  };
  const handleEditSubmit = async () => {
    if (validateFormData()) {
      // You can send formData to your API endpoint here
      //   const selectedAccess = Object.entries(formData.portalAccess)
      // .filter(([key, value]) => value)
      // .map(([key]) => key);
      const stationcode = stationList.find(lst => lst.port_code == formData.station_code);
      // console.log("🚀 ~ handleSubmit ~ stationcode:", stationcode)
      const portalAccessArray = Object.keys(formData.portal_access)
        .filter(key => formData.portal_access[key]);

      // Create the final data object for submission
      const finalData = {
        ...formData,
        user_id: editId,
        // port_address: stationcode.port_address,
        // portal_access: portalAccessArray
      };
      console.log('fdaa', finalData);
      // try {
      //   const res = await withRFSToken.post(SUBMITLIST, finalData);
      //   console.log("response==>", res.data);
      //   if (res.data.status === 400) {
      //     console.log('www', res.data.message)
      //     toast.error(res.data.message);
      //   } else {
      //     setFormData({ first_name: '', last_name: '', email: '', phone_number: '', station_code: '', })
      //     reloadGrid();
      //     handleModalClose();
      //     setEditId('');
      //   }

      // } catch (error) {
      //   console.error('Error sending request:', error);
      // }

    }

  };
  const handleShowConfirmation = (deleteFunction) => {
    setShowConfirmation(true);
    setDeleteFunction(() => deleteFunction);
  };
  const handleConfirmDelete = () => {
    // deleteRow(gridSelect);
    deleteFunction(deleteId)
    setShowConfirmation(false);
  };

  const handleCancelDelete = () => {
    setDeleteId('')
    setShowConfirmation(false);
  };
  const deleteRow = async (selectedId) => {

    try {
      const res = await withRFSToken.post(AIRLINEREMOVEUSER, { user_id: selectedId });
      if (res.data.response_code == 200) {
        toast.success('User Data Removed Successfully')
        // fetchData();
        setTimeout(() => {
          setIsLoading(false);
          window.$(gridRef.current).jqxGrid('updatebounddata');
        }, 1);
        setDeleteId('');
      } else {
        toast.error(res.data.response_msg);
      }
    } catch (error) {
      console.error('Error sending request:', error);
    }
  };
  const sBack = localStorage.getItem('SettingsBack')
  return (
    <>
      {console.log('formData', formData)}
        {modalConf &&
        <ConfModal
          header={confData.header}
          subHeader={confData.subHeader}
          modalConf={tabChangeConf}
          closeModal={confModalClose}
          primaryBtn={confData.primaryBtn}
          secondaryBtn={confData.secondaryBtn}
        />
      }

      <div className='col-9 col-xxl-9 stting_right'>
        <div className='settingbg_right'>
          <h4>User Setting</h4>
          <p>Set your notification preferences for when you are in or away from the dashboard.</p>
          <div className='d-flex justify-content-between'>
            <div>
              <Button variant="primary createplan" onClick={handleAddButtonClick} >
                <FontAwesomeIcon icon={faPlus} /> Add User
              </Button>
            </div>
            <div className='rastatus'>
              <span>Status : </span>
              <Form.Select>
                <option>All</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </Form.Select>
            </div>

          </div>
          {!isLoading && <div ref={gridRef} className='bookinggrid userstting'></div>}
        </div>
      </div>
      {/* </div> */}
      <Modal show={modalShow} centered onHide={handleModalClose} className='addfrom' >
        <Modal.Header closeButton>
          <Modal.Title>
            {editId &&
              !editId == '' ? (
              <>
                Edit User
              </>
            ) : (
              <>
                Add User
              </>
            )
            }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Form.Group as={Row} className='mb-2'>
            <Col sm="6">
              <Form.Label>First Name</Form.Label>
              <Form.Control type="text" name='first_name' placeholder="First Name" value={formData.first_name} onChange={handleChange} />
            </Col>
            <Col sm="6">

              <Form.Label>Last Name</Form.Label>
              <Form.Control type="text" placeholder="Last Name" name='last_name' value={formData.last_name} onChange={handleChange} />

            </Col>
          </Form.Group>

          <Form.Group as={Row} className='mb-2'>
            <Col sm="6">
              <Form.Label>Email id</Form.Label>
              <Form.Control type="text" name='email' placeholder="Email id" value={formData.email} onChange={handleChange} />
            </Col>
            <Col sm="6">
              <Form.Label>Telephone No</Form.Label>
              <Form.Control type="number" maxLength='12' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12); }} name='phone_number' value={formData.phone_number} onChange={handleChange} placeholder="Number" />

            </Col>
          </Form.Group>

          <Form.Group controlId="dropdown" className='mb-3' as={Row}>
            <Col sm='6'>
              <Form.Label>Select Station</Form.Label>
              {/* <Form.Select aria-label="Default select example" name="station_code" value={formData.station_code} onChange={handleChange}>
                  <option>Select Station</option>
                  {console.log('ddd', stationList)}
                  {stationList && stationList.map((list, index) => (
                    <option key={index} value={list.value}>{list.label}</option>
                  ))} */}
              {/* <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select> */}
              <Select
                options={stationList}
                onChange={(selected) => {
                  const updatedData = { ...formData, station_code: selected.value };
                  setFormData(updatedData);
                }}
                placeholder="Select Station"
                className='down_selct'
                name="station_code"
                value={stationList.find(option => option.value === formData.station_code)}
              />
            </Col>
            <Col sm='6'>
              <Form.Label>Departments</Form.Label>
              <Select
                options={userRole}
                onChange={(selected) => {
                  const updatedData = { ...formData, user_type: selected.value };
                  setFormData(updatedData);
                }}
                placeholder="Select Station"
                className='down_selct'
                name="user_type"
                value={userRole.find(option => option.value === formData.user_type)}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} className='mb-2'>
            <Col sm="12">
              <Form.Label>Address</Form.Label>
              <Form.Control as="textarea" rows={3} name='address' onChange={handleChange} />
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>

          <Button variant="primary" onClick={handleSubmit}>
            {editId && !editId == '' ? 'Update' : 'Add'} User
          </Button>
          {/* ) : (
                <Button variant="primary" onClick={handleSubmit}>
                  Add User
                </Button>
              )
              } */}

        </Modal.Footer>
      </Modal>
      <Modal className='raintrac' show={showConfirmation} onHide={() => setShowConfirmation(false)}>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h2>Confirm Delete</h2>
          <p>If you proceed with the change, user data will be removed.
            Are you sure you want to continue?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelDelete}>
            No
          </Button>
          <Button variant="primary" onClick={handleConfirmDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* </div>
      </div> */}
    </>
  )
}

export default UserSettings;